import React from "react";
import Header from "../Header/Header";
import LeftMenu from "../LeftMenu/LeftMenu.tsx";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { GRAY2 } from "../StyledComponents/Color/Color";


export default function Dashboard() {
  return (
    <Box>
      <Header />
      <Box
        sx={{
          position: "fixed",
          background: GRAY2,
          height: "calc(100vh - 64px)",
          width: "248px",
          top: 64,
          overflowY: "auto"
        }}
      >
        <LeftMenu />
      </Box>

      <Box
        sx={{
          minHeight: "calc(100vh - 64px)",
          minWidth: "calc(100% - 248px)",
          marginLeft: "248px",
          marginTop: "64px"
        }}
      >
        <Box
          sx={{
            marginLeft: 2,
            marginRight: 2,
            marginBottom: 2
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}
